<template>
    <div
        class="wizard-container"
        :class="[
            {
                'wizard-container--filemanager': isFilemanagerActive,
                'wizard-container--fileeditor': isFileeditorActive
            }
        ]"
    >
        <app-wizard v-bind:page="page"></app-wizard>
        <app-filemanager v-if="isFilemanagerActive"></app-filemanager>
        <app-fileeditor v-if="isFileeditorActive"></app-fileeditor>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from '@/components/assorted/Header.vue';
import Wizard from '@/components/assorted/Wizard.vue';
import Filemanager from '@/components/assorted/Filemanager.vue';
import Fileeditor from '@/components/assorted/Fileeditor.vue';

export default {
    data() {
        return {};
    },
    components: {
        'app-header': Header,
        'app-wizard': Wizard,
        'app-filemanager': Filemanager,
        'app-fileeditor': Fileeditor
    },
    methods: {},
    computed: {
        ...mapGetters(['isFilemanagerActive', 'isFileeditorActive']),
        page() {
            return parseInt(this.$route.params.page) || 0;
        }
    },
    created() {}
};
</script>
